<template>
  <div v-cloak v-loading.fullscreen.lock="dataLoading"
       element-loading-text="Loading, please wait..."
       element-loading-spinner="el-icon-loading"
       element-loading-background="rgba(0, 0, 0, 0.8)">

    <el-dialog
      @opened="openDialog"
      title="Config Function Permission"
      :visible.sync="configRoleFunctionDialogVisible"
      :close-on-click-modal="false"
      :center="true"
      width="800px"
      size="small"
      @closed ="closeDialog"
    >
      Select Function Permissions For Role: {{rowVal.role_name}}
      <div style="height: 70vh;overflow-y: auto;">
        <tree-selection ref="treeSelection" :type="type" :showReadWrite="true" :orgList="orgList"></tree-selection>
      </div>

      <span slot="footer" class="dialog-footer">
              <el-button size="small"  type="success" @click="saveRoleFunction">Save</el-button>
              <el-button size="small" class="ml30" @click="configRoleFunctionDialogVisible = false">close</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import treeSelection from '@/view/acs/tree/tree_selection'

  export default {
    components: {
      treeSelection
    },
    props: {
      type: {
        type: String,
        default: ''
      }
    },
    data(){
      return{
        rowVal:{},
        configRoleFunctionDialogVisible: false,
        dataLoading: false,
        structure:[],
        orgList:[],
      }
    },
    computed: {
    },
    created(){
    },


    methods: {
      closeDialog(){

      },
      showConfigRoleFunction(row){
        this.rowVal = row;
        this.configRoleFunctionDialogVisible = true;
        this.getOrgListByRoleId();
      },
      getOrgListByRoleId(){
        this.http.get(`${this.baseAcsUrl}/acs/user-data-instance-tag/getOrgByRole`, { roleId: this.rowVal.id }).then(res => {
          this.orgList = res.data || [];
        });
      },
      hideConfigRoleFunction(){
        this.configRoleFunctionDialogVisible = false;
      },
      saveRoleFunction(){
       let checkedStructure = this.$refs.treeSelection.getCheckedNodesForReadWrite(false);
       console.log(checkedStructure);
       let roleFuntionList = {};
       let funcitonList = [];
        roleFuntionList.roleId = this.rowVal.id;
       checkedStructure.forEach(v =>{
         let item = {};
         item.roleId =
         item.functionId = v.id;
         item.isWrite = v.writeChecked;
         item.isRead = v.readChecked;
         item.orgCodePaths = v.orgCodePaths;
         funcitonList.push(item);
       });
        roleFuntionList.roleFunctionPermissions = funcitonList;


        let url = this.baseAcsUrl + '/acs/role-function/save';
        this.dataLoading = true;
        this.http.post(url,roleFuntionList).then(resp =>{
          this.$message.success('Successful operation ');
          this.configRoleFunctionDialogVisible = false;
          this.dataLoading = false;
          this.$emit("saveSuccess");
        } ).catch(error => {
          this.dataLoading = false;
          console.info(error);
          this.$emit("saveFail");
        });
      },
      openDialog(){
        this.dataLoading = true;
        let url = this.baseAcsUrl + '/acs/role-function/get-role-function-permission?role_id='+this.rowVal.id;
        this.http.get(url).then(resp => {
          this.dataLoading = false;
          let data = resp.data;
          if(data){
            this.$refs.treeSelection.init(data, 'functionName', 'isRead', 'isWrite');
          }else{
            this.$message.warning("Empty Data! ");
          }
        }).catch(error =>{
          this.dataLoading = false;
        })

      }
    }
  }

</script>

<style lang="scss" scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumb{
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .title{
    margin-left: 16px;
    font-size: 20px;
  }
 .el-form-item /deep/ .el-select{
   display: inline-block;
   width: 86%;
  }
  .add-banner-group  /deep/ .el-form-item__label{
    width: 148px !important;
  }
  .add-banner-group /deep/ .el-form-item__content{
    margin-left: 148px!important;
  }

  div /deep/ .el-dialog {
    margin-top: 0 !important;
    position: fixed !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>



// WEBPACK FOOTER //
// src/view/acs/role/dialog/config_role_function.vue